import React from 'react'
import BranchDetail from '../branch_components/branch_detail'

export default function Main() {
  return <BranchDetail />
}
